export default class MembroFamiliar {
  constructor(id= '',nome = '', idade = '', parentensco = '', estado_civil = '', profissao = '', renda_bruta = '', periodo = '') {
    this.id = id;
    this.nome = nome;
    this.idade = idade;
    this.parentensco = parentensco;
    this.estado_civil = estado_civil;
    this.profissao = profissao;
    this.renda_bruta = renda_bruta;
    this.periodo = periodo;
  }
}
